import { render, staticRenderFns } from "./OrderPrivacyPolicy.vue?vue&type=template&id=7527fef5&scoped=true&"
import script from "./OrderPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./OrderPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./OrderPrivacyPolicy.vue?vue&type=style&index=0&id=7527fef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7527fef5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCheckbox,VDialog,VIcon})
